import { NameValue } from 'projects/sepidz-web-framework/src/lib/models/name-value';

export const OCCASION_ITEMS: NameValue[] = [
  {Name: 'عنوان مشتری', Value: '[CustomerTitle]'},
  {Name: 'نام مشتری', Value: '[CustomerName]'},
  {Name: 'عنوان رستوران', Value: '[RestaurantTitle]'},
  {Name: 'تلفن رستوران', Value: '[RestaurantPhoneNumber]'},
  {Name: 'آدرس رستوران', Value: '[RestaurantAddress]'},
];

export const GROUP_ITEMS: NameValue[] = [
  ...OCCASION_ITEMS,
  {Name: 'جمع خرید', Value: '[TotalPurchase]'},
  {Name: 'گروه مشتری', Value: '[CustomerCategory]'},
  {Name: 'تعداد خرید', Value: '[PurchaseCount]'},
];

export enum MessageTemplateType
{
    occasion=1,
    groups=2
}